export default __webpack_public_path__ + "static/media/MainIcon4.ef0ddd7c.svg";